import { isInternalAttributeName } from '../attributes';

export const deviceGroupAttributes = [
  'region',
  'routingDomain',
  'siteName',
  'stpDomain',
] as const;

export type DeviceGroupAttribute = (typeof deviceGroupAttributes)[number];

/**
 * Group-by options offered in the UI. Options without an internal attribute
 * (region) are backed by labels only, so they need the labels feature.
 */
export const getAvailableDeviceGroupAttributes = ({
  labelsEnabled,
}: {
  labelsEnabled: boolean;
}): readonly DeviceGroupAttribute[] =>
  labelsEnabled
    ? deviceGroupAttributes
    : deviceGroupAttributes.filter(isInternalAttributeName);
